<template>
  <div ref="observerDiv">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'OverlayComponent',
  mixins: [],
  props: {
    elementToOverlay: {
      type: HTMLElement
    }
  },

  data() {
    return {}
  },
  computed: {},
  watch: {
    elementToOverlay: {
      handler(newValue) {
        if (newValue != null) {
          newValue.appendChild(this.overlayDiv)
        }
      },
      immediate: true
    }
  },
  beforeCreate() {
    this.overlayDiv = document.createElement('div')
    this.overlayDiv.style.position = 'absolute'
    this.overlayDiv.style.left = '0px'
    this.overlayDiv.style.top = '0px'
    this.overlayDiv.style.height = '100%'
    this.overlayDiv.style.width = '100%'
    this.overlayDiv.style['z-index'] = 9999
    this.overlayDiv.style['flex-direction'] = 'row'
    this.overlayDiv.style['pointer-events'] = 'none'
    this.overlayDiv.background = 'transparent'
  },
  mounted() {
    this.observer = new MutationObserver((mutations) => {
      this.attachSlotsToOverlay()
    })
    this.observer.observe(this.$refs.observerDiv, { childList: true })
    this.attachSlotsToOverlay()
  },
  beforeDestroy() {},
  methods: {
    attachSlotsToOverlay() {
      if (this.$slots.default != null) {
        this.$slots.default.forEach((element) =>
          this.overlayDiv.appendChild(element.elm)
        )
      }
    }
  }
}
</script>

<style scoped></style>
